<script lang="ts" setup>
import AnimatedNumber from '../common/AnimatedNumber.vue';
import useI18NAsync from '~/composables/i18nAsync';
const i18nSuspense = useI18NAsync('components/homepage/stats');
</script>
<template>
  <div
    class="white--text flex flex-column px-10px--sm px-30px py-50px homepage-stats-container align-items-center grid-gap-40px"
  >
    <div class="title text-center">
      <i18nSuspense ikey="onDemandManufacturing" />
    </div>
    <div class="grid grid-3-columns grid-1-columns--sm text-center grid-gap-20px">
      <div class="flex flex-column align-items-center justify-center stats-content">
        <div class="stats-number flex flex-row"><AnimatedNumber :to="180" />+</div>
        <i18nSuspense tag="span" class="subtitle" ikey="qualifiedServiceProviders" />
      </div>
      <div class="flex flex-column align-items-center justify-center stats-content">
        <div class="stats-number flex flex-row"><AnimatedNumber :to="13" />K</div>
        <i18nSuspense tag="span" class="subtitle" ikey="manufacturingMachines" />
      </div>
      <div class="flex flex-column align-items-center justify-center stats-content">
        <div class="stats-number flex flex-row blue-2--text"><AnimatedNumber :to="100" />%</div>
        <i18nSuspense tag="span" class="subtitle" ikey="securePayment" />
      </div>
    </div>
    <div class="subtitle text-center stats-subtitle">
      <i18nSuspense ikey="manufacturingProcesses" />
    </div>
  </div>
</template>
<style lang="scss" scoped>
@use '/assets/scss/variables' as variables;

.homepage-stats-container {
  background-size: cover;
  background-position: center;
  background-image: url('/assets/images/homepage/HomepageStatsBanner.webp');
}

.stats-number {
  font-size: 80px;
  line-height: 80px;

  @include variables.for-sm {
    font-size: 50px;
    line-height: 50px;
  }
}
</style>
